module.exports = __webpack_public_path__ + "b011c35ef7e2294243e9f8152376a2dd.png";